import Reflux from "reflux";

const DesignChooserActions = Reflux.createActions([
  "chooseItem",
  "selectTab",
  "selectItem",
  "selectLayout",
  "toggleList",
  "toggleTheme",
  "changeView",
  "openDialog",
  "closeDialog",
  "loadDesign",
]);

export default DesignChooserActions;
